// extracted by mini-css-extract-plugin
export default {"layout":"ProjectsLayout_layout__F9JnO","sidebar":"ProjectsLayout_sidebar__BXQIF","content":"ProjectsLayout_content__VE+lC"};